module.exports = __webpack_public_path__ + "f941b69ca509553e38312e282f1d8482.jpg";